<template>
  <div role="group" class="mb-3">
    <b-form-group :label="question">
      <b-form-input v-model="answer"></b-form-input>
    </b-form-group>
  </div>
</template>

<script>
export default {
  name: "AccountText",
  props: {
    body: {
      type: Object,
      default() {
        return {};
      },
    },
    question: {
      type: String,
      default: "",
    },
    preAnswer: {
      type: String,
      default: "",
    },
    answerList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      answer: "",
    };
  },
  mounted() {
    this.answer = this.preAnswer;
    this.$emit("load-next", this.body.next);
  },
};
</script>

<style></style>
